(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrSectionDeleteController',TrSectionDeleteController);

    TrSectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrSection','$scope'];

    function TrSectionDeleteController($uibModalInstance, entity, TrSection,$scope) {
        var vm = this;

        vm.trSection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrSection.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
